import { white } from '@kmns-internal/furikake'
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import {
  ImporoveExcelConvertStatusEnum,
  type ImproveExcelConverts,
} from '@ulysses-inc/harami_api_client'
import { type Dispatch, type FC, type SetStateAction, useEffect } from 'react'
import { getStatusNameForDownload } from 'src/constants/improveStatus'
import date from 'src/exShared/util/date'
import { getStatusBadge } from './ImproveExcelConversionLogStatus'

interface OwnProps {
  logs: ImproveExcelConverts[]
  getImproveExcelConversionLogFiles: (fileUUIDs: string[]) => void
  chooseLogUUIDs: { [key: string]: string }
  setChooseLogUUIDs: Dispatch<SetStateAction<{ [key: string]: string }>>
}

const ImproveExcelConversionLogList: FC<OwnProps> = (props: OwnProps) => {
  useEffect(() => {
    Object.keys(props.chooseLogUUIDs).forEach(logUUID => {
      const isContain =
        props.logs.findIndex(log => log.logFile?.file?.uuid === logUUID) >= 0
      if (!isContain) {
        // eslint-disable-next-line react-hooks/immutability -- 関数の宣言順序による既存パターンのため、リファクタリング時に修正する
        handleCheckLog(logUUID, false)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.logs])

  const handleCheckLog = (fileUUID: string | undefined, checked: boolean) => {
    if (fileUUID === undefined) {
      return
    }
    if (checked) {
      // eslint-disable-next-line react-hooks/immutability -- 関数の宣言順序による既存パターンのため、リファクタリング時に修正する
      props.chooseLogUUIDs[fileUUID] = fileUUID
      props.setChooseLogUUIDs({ ...props.chooseLogUUIDs })
    } else {
      delete props.chooseLogUUIDs[fileUUID]
      props.setChooseLogUUIDs({ ...props.chooseLogUUIDs })
    }
  }

  return (
    <TableContainer sx={{ overflow: 'auto', flex: 1, position: 'relative' }}>
      <Table sx={{ backgroundColor: white }} stickyHeader>
        <TableHead>
          <TableRow sx={{ backgroundColor: white }}>
            <TableCell size="small" sx={{ fontWeight: 'bold' }}>
              出力日
            </TableCell>
            <TableCell size="small" sx={{ fontWeight: 'bold' }}>
              出力者
            </TableCell>
            <TableCell size="small" sx={{ fontWeight: 'bold' }}>
              カイゼンステータス
            </TableCell>
            <TableCell size="small" sx={{ fontWeight: 'bold' }}>
              実行結果
            </TableCell>
            <TableCell size="small" />
          </TableRow>
        </TableHead>
        <TableBody>
          {props.logs.map((log: ImproveExcelConverts, index: number) => (
            <TableRow key={log.id ?? index} sx={{ backgroundColor: white }}>
              <TableCell size="small">
                <Typography variant="body2">
                  {date.formatYYYYMMDD(log.createdAt)}
                </Typography>
              </TableCell>
              <TableCell size="small">
                <Typography variant="body2">{log.userName || ''}</Typography>
              </TableCell>
              <TableCell size="small">
                <Typography variant="body2">
                  {log.improveStatus?.status
                    ? getStatusNameForDownload(log.improveStatus.status)
                    : '不明'}
                </Typography>
              </TableCell>
              <TableCell size="small">{getStatusBadge(log.status)}</TableCell>
              <TableCell size="small" sx={{ p: 0 }}>
                {log.id !== undefined &&
                  log.status === ImporoveExcelConvertStatusEnum.SUCCESS && (
                    <Button
                      onClick={() => {
                        const fileUUID = log.logFile?.file?.uuid
                        if (fileUUID === undefined) return
                        props.getImproveExcelConversionLogFiles([fileUUID])
                      }}
                      variant="text"
                      size="small"
                    >
                      ダウンロード
                    </Button>
                  )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ImproveExcelConversionLogList
